import { IReduxState } from 'types/redux';

export const zoneGuardsListSelector = (state: IReduxState) => state.zoneGuards.list;

export const zoneGuardMapSelector = (state: IReduxState) => state.zoneGuards.map;
